import { Component, HostListener, OnInit, ViewChild, ElementRef, AfterViewInit, TemplateRef, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ShopinfoModel, DepartmentModel } from '../model/shopinfo.model';
import { ShopinfoService } from '../shopinfo.service';
import { AreaService } from '../../area/area.service';
import { DepartmentService } from '../../department/department.service';
import { SnackBarData } from 'src/app/common/components/snackbar/model/snackbar.model';
import { SnackBarService } from 'src/app/common/components/snackbar/snackbar.service';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { ConfirmDialogComponent, ConfirmDialogModel } from 'src/app/common/components/confirm-dialog/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { DirtyCheck } from 'src/app/common/guards/form-deactivate.guard';
import { ConfirmDialogService } from 'src/app/common/components/confirm-dialog/confirm-dialog.service';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { PermissionService } from 'src/app/auth/permission.service';
import { PayrollGroupService } from '../../../payroll/payroll-group/payroll-group.service';
import moment from 'moment';

@Component({
  selector: 'app-shop-edit',
  templateUrl: './shop-edit.component.html',
  styleUrls: ['./shop-edit.component.scss'],
  standalone: false
})
export class ShopEditComponent implements DirtyCheck, AfterViewInit {
  title: string = "New Shop";
  editForm: FormGroup;
  shopInfo: ShopinfoModel = { departments: [], payroll_groups: [] };
  isFormDirty: boolean = false;
  payrollGroupSearch = new FormControl<string>('');
  initialFormValue: any;
  shoptype: any;
  areaList: any;
  departmentList: DepartmentModel[] = [];
  displayedColumns: string[] = ['code', 'name'];
  sushishop_list: any;
  mainshop_list: any;
  bento_shop_list: any;
  selected_shop_type: any;
  is_display_bento_shop: boolean = false;
  is_display_dt_shops: boolean = false;
  isDisabled: boolean = false;
  selectedBentoShop: any;
  selectedSushiShop: any;
  mainShop: any;
  shopList: any;
  userData: any;
  isDepartmentsDirty = false;
  initialDepartments: any[] = [];
  payrollGroups: any[] = [];
  filteredPayrollGroups: any[] = [];
  isPublishing: boolean = false;
  isSettingProdMode: boolean = false;

  @ViewChild('payrollGroupNameInput') payrollGroupNameInput!: ElementRef<HTMLInputElement>; // For manual input value set
  @ViewChild('publishDialog') publishDialog!: TemplateRef<any>;
  @ViewChild('prodModeWarningDialog') prodModeWarningDialog!: TemplateRef<any>;
  @ViewChild('prodModeLoaderDialog') prodModeLoaderDialog!: TemplateRef<any>;
  permission: any;
  publishStatusMessage: string = '';
  publishSuccess: boolean = false;
  prodModeStatusMessage: string = '';
  prodModeSuccess: boolean = false;
  prodModeStep: number = 1;
  isSummarizeSalesToHq: boolean = true;

  constructor(private router: Router,
    private builder: FormBuilder,
    private route: ActivatedRoute,
    private shopService: ShopinfoService,
    private AreaService: AreaService,
    private DepartmentService: DepartmentService,
    private snackBarService: SnackBarService,
    public dialog: MatDialog,
    private confirmDialogService: ConfirmDialogService,
    private permissionService: PermissionService,
    private payrollGroupService: PayrollGroupService,
    private cdr: ChangeDetectorRef
  ) {
    const userDetailsData = sessionStorage.getItem('user');
    if (userDetailsData) {
      this.userData = JSON.parse(userDetailsData);
    }
    this.shopInfo = { departments: [], payroll_groups: [] };

    let shopId = this.route.snapshot.paramMap.get('id');
    this.editForm = this.builder.group({
      code: this.builder.control(this.shopInfo.code, [Validators.required, Validators.maxLength(10)]),
      name: this.builder.control(this.shopInfo.name, [Validators.required, Validators.maxLength(50)]),
      description: this.builder.control(this.shopInfo.description),
      shop_type: this.builder.control(this.shopInfo.shop_type, [Validators.required]),
      area_id: this.builder.control(this.shopInfo.area_id, [Validators.required]),
      address: this.builder.control(this.shopInfo.address, [Validators.required]),
      city: this.builder.control(this.shopInfo.city, []),
      state: this.builder.control(this.shopInfo.state, []),
      country: this.builder.control(this.shopInfo.country, []),
      is_excluded_summary: this.builder.control(1, []),
      is_in_production_mode: this.builder.control(this.shopInfo.is_in_production_mode || 0, []),
      zip_code: this.builder.control(this.shopInfo.zip_code, []),
      start_date: this.builder.control(this.shopInfo.start_date, []),
      main_shop_id: this.builder.control(this.shopInfo.main_shop_id || ''),
      dt_sushi_shop_id: this.builder.control((this.shopInfo as any).dt_sushi_shop_id || ''),
      dt_bento_shop_id: this.builder.control((this.shopInfo as any).dt_bento_shop_id || ''),
      payroll_group_id: this.builder.control(''),
      cost_code: this.builder.control('', [Validators.maxLength(10)]),
    });

    this.editForm.get('code')?.valueChanges.subscribe(value => {
      if (value) {
        const uppercased = value.toUpperCase();
        if (value !== uppercased) {
          this.editForm.get('code')?.setValue(uppercased, { emitEvent: false });
        }
      }
    });

    // Native editForm.dirty tracks UI-based changes seamlessly.

    // FIX: Defer setShopInfo to ngOnInit to avoid race with master data loads
    if (shopId !== null && parseInt(shopId) !== 0) {
      // Will call in ngOnInit
    }
    this.permission = this.permissionService.getRowPermission(this.permissionService.getPagePermission("shop"), shopId);

  }

  ngOnInit(): void {
    this.loadMasterData();
    this.loadPayrollGroups(); // FIX: Load from service with correct requestData
    let shopId = this.route.snapshot.paramMap.get('id');
    if (shopId !== null && parseInt(shopId) !== 0) {
      this.setShopInfo(shopId);
    } else {
      this.updateExcludeSummaryDisabledState();
    }
  }

  ngAfterViewInit(): void {
    // FIX: Ensure input displays correctly after view init
    this.updatePayrollInput();
  }

  // FIX: Load payroll groups from service using provided requestData
  // FIX: Updated loadPayrollGroups() to map response to match shop API structure (payroll_group_id, group_name, group_code)
  loadPayrollGroups(): void {
    const requestData = {
      search: {
        filters: {
          column: [],
          scope: { limit: 100, offset: 0 },
        },
        sort: [{ column: "code", order: "asc" }],
      },
    };
    this.payrollGroupService.getList(requestData).subscribe({
      next: (response: any) => {
        if (response.status === 'SUCCESS') {
          // FIX: Map to {payroll_group_id, group_name, group_code} to match shop API and form expectations
          this.payrollGroups = (response.data.payroll_groups || []).map((group: any) => ({
            payroll_group_id: group.id,
            group_name: group.name,
            // Add other fields if needed, e.g., description: group.description
          }));
          this.filteredPayrollGroups = this.payrollGroups.slice();
          // FIX: Update input if form already has id (handles async load)
          this.updatePayrollInput();
        }
      },
      error: (error) => {
        // Handle error, e.g., snackbar
        console.error('Failed to load payroll groups:', error);
      }
    });
  }

  // FIX: Updated getPayrollGroupName to use correct keys (group_name)
  getPayrollGroupName(id: any): string {
    const found = this.payrollGroups.find((g: any) => g.payroll_group_id === id);
    return found ? found.group_name : '';
  }

  // FIX: Updated selectPayrollGroup to use mapped keys
  selectPayrollGroup(event: MatAutocompleteSelectedEvent) {
    const group = event.option.value;
    this.editForm.get('payroll_group_id')?.setValue(group.payroll_group_id);
    this.editForm.get('group_code')?.setValue(group.group_code || '');
    this.payrollGroupSearch.setValue(group.group_name);
    if (this.payrollGroupNameInput) {
      this.payrollGroupNameInput.nativeElement.value = group.group_name;
    }
  }

  // FIX: In setShopInfo(), after patching payroll, ensure updatePayrollInput uses the correct name
  // (Already calls setTimeout(() => this.updatePayrollInput(), 0); which now works with mapped keys)

  // No changes needed to filterPayrollGroups or clearPayrollGroup (they use group_name for filter/display)

  // FIX: Optional - If cost_code should also come from service (but in shop API it's separate), you could add it to map if service has it; otherwise, keep patching from shop data as-is

  // FIX: New method to manually set autocomplete input value (handles async races)
  private updatePayrollInput(): void {
    if (this.editForm.get('payroll_group_id')?.value) {
      const name = this.getPayrollGroupName(this.editForm.get('payroll_group_id')?.value);
      this.payrollGroupSearch.setValue(name);
      if (this.payrollGroupNameInput) {
        this.payrollGroupNameInput.nativeElement.value = name;
      }
    } else {
      this.payrollGroupSearch.setValue('');
    }
  }

  get isProductionMode(): boolean {
    return Number(this.shopInfo?.is_in_production_mode) === 1;
  }

  get isExcludeSummaryDisabled(): boolean {
    return !(this.isProductionMode && this.permission?.can_edit);
  }

  updateExcludeSummaryDisabledState(): void {
    if (this.isProductionMode && this.permission?.can_edit) {
      this.editForm?.get('is_excluded_summary')?.enable({ emitEvent: false });
    } else {
      this.editForm?.get('is_excluded_summary')?.disable({ emitEvent: false });
    }
  }

  isDirty(): boolean {
    return this.editForm.dirty || this.payrollGroupSearch.dirty || this.isDepartmentsDirty;
  }

  navBack(): void {
    if (this.userData?.user_type == 'HQ') {
      this.router.navigate(['/system/shop']);
    }
    if (this.userData?.user_type == 'SHOP') {
      this.reload();
    }
  }

  async reload(): Promise<void> {
    let shopId = this.route.snapshot.paramMap.get('id');
    if (this.isDirty()) {
      const message = "Are you sure you want to discard your changes? Your changes will be lost.";
      const dialogData = new ConfirmDialogModel("Discard unsaved changes?", message);
      const result = await this.confirmDialogService.openDialog(dialogData);
      if (result) {
        this.setShopInfo(shopId);
        this.editForm.markAsPristine();
        this.payrollGroupSearch.markAsPristine();
        this.isDepartmentsDirty = false;
      }
    } else {
      this.setShopInfo(shopId);
    }
  }

  loadMasterData(): void {
    let requestData = { search: { filters: { scope: { limit: 100000, offset: 0 } }, sort: [] } };

    // FIX: Departments - populate for new; edit uses API
    this.DepartmentService.getDepartmentList(requestData).subscribe({
      next: (response: any) => {
        if (response.status == 'SUCCESS') {
          this.departmentList = response.data.departments;
          // FIX: For new shop, init departments with is_exist: false
          if (!this.shopInfo.id) {
            this.shopInfo.departments = this.departmentList.map((dept: DepartmentModel) => ({
              id: undefined,
              department_id: dept.id,
              code: dept.code,
              name: dept.name,
              is_exist: false
            }));
            this.initialDepartments = JSON.parse(JSON.stringify(this.shopInfo.departments));
          }
        }
      }
    });

    this.AreaService.getAreaList(requestData).subscribe({
      next: (response: any) => {
        if (response.status == 'SUCCESS') {
          this.areaList = response.data.areas;
        }
      }
    });

    this.shopService.getShopTypeList().subscribe({
      next: (response: any) => {
        if (response.status == 'SUCCESS') {
          this.shoptype = response.data.shop_types;
        }
      }
    });

    this.shopService.getShopList(requestData).subscribe({
      next: (response: any) => {
        if (response.status == 'SUCCESS') {
          this.shopList = response.data.shops;
          this.mainshop_list = this.shopList.filter((m: any) => m.shop_type === 'SUSHI');
          this.sushishop_list = this.shopList.filter((s: any) => s.shop_type === 'SUSHI');
          this.bento_shop_list = this.shopList.filter((b: any) => b.shop_type === 'BENTO');
        }
      }
    });
  }

  setShopInfo(shopId: any): void {
    const parsedShopId = parseInt(shopId, 10) || 0;
    this.shopService.getShopById(parsedShopId).subscribe({
      next: (response) => {
        if (response.status == 'SUCCESS') {
          // FIX: Use data.shops (object in API)
          this.shopInfo = response.data.shops;
          if (!this.shopInfo.departments) {
            this.shopInfo.departments = [];
          }
          // FIX: For edit, API provides full departments with flags; set initial
          this.initialDepartments = JSON.parse(JSON.stringify(this.shopInfo.departments));
          this.departmentList = response.data.department_list || []; // Optional, if needed elsewhere

          this.shoptype = response.data.shop_types;
          this.areaList = response.data.area_list;
          this.mainshop_list = response.data.main_shop;
          this.sushishop_list = response.data.sushi_shop;
          this.bento_shop_list = response.data.bento_shop;
          this.selected_shop_type = this.shopInfo.shop_type; // FIX: Direct from shopInfo
          this.mainShop = Number(this.shopInfo.main_shop_id || response.data.main_shop_id || 0); // FIX: Fallback
          this.selectedSushiShop = Number(response.data.selected_sushi_shop_id);
          this.selectedBentoShop = Number(response.data.selected_bento_shop_id);

          if (this.selected_shop_type === 'SUSHI') {
            this.is_display_bento_shop = false;
            this.is_display_dt_shops = false;
            this.isDisabled = true;
          } else if (this.selected_shop_type === 'OO') {
            this.is_display_bento_shop = false;
            this.is_display_dt_shops = false;
            this.isDisabled = false;
          } else if (this.selected_shop_type === 'BENTO') {
            this.is_display_bento_shop = true;
            this.is_display_dt_shops = false;
            this.isDisabled = true;
          } else if (this.selected_shop_type === 'DT') {
            this.is_display_bento_shop = false;
            this.is_display_dt_shops = true;
            this.isDisabled = false;
          }
          // FIX: Patch main form fields
          this.shopInfo.is_in_production_mode = Number(this.shopInfo.is_in_production_mode || 0);
          if (this.isProductionMode) {
            this.shopInfo.is_excluded_summary = Number(this.shopInfo.is_excluded_summary) === 1 ? 1 : 0;
          } else {
            this.shopInfo.is_excluded_summary = 1;
          }
          this.updateExcludeSummaryDisabledState();

          this.editForm.patchValue(this.shopInfo);
          this.editForm.get('is_excluded_summary')?.setValue(this.shopInfo.is_excluded_summary);
          if (this.shopInfo.start_date) {
            this.editForm.get('start_date')?.setValue(moment(this.shopInfo.start_date));
          } else {
            this.editForm.get('start_date')?.setValue(null);
          }

          // FIX: Extract and patch payroll fields from API
          if (this.shopInfo.payroll_groups && this.shopInfo.payroll_groups.length > 0) {
            const pg = this.shopInfo.payroll_groups[0];
            this.editForm.patchValue({
              payroll_group_id: pg.payroll_group_id,
              cost_code: pg.cost_code
            });
            // FIX: Update input display (handles if groups not loaded yet)
            setTimeout(() => this.updatePayrollInput(), 0); // Defer to next tick
          }

          this.title = this.getTitle();
          this.editForm.markAsPristine();
          this.payrollGroupSearch.markAsPristine();
          this.isDepartmentsDirty = false;
        } else {
          let snackBarData: SnackBarData = {
            message: response.message,
            title: 'Failed!!!',
            type: 'error'
          };
          this.snackBarService.openSnackBar(snackBarData);
        }
      },
      error: (error) => {
        let snackBarData: SnackBarData = {
          message: 'Failed to get data from server. Connection to the server failed.',
          title: 'Failed!!!',
          type: 'error'
        };
        this.snackBarService.openSnackBar(snackBarData);
      }
    });
  }

  getTitle(): string {
    if (this.userData?.user_type == 'SHOP') {
      let title = (this.shopInfo.id == 0) ? "New Shop" : "" + this.shopInfo.name;
      return title;
    }
    let title = (this.shopInfo.id == 0) ? "New Shop" : "Editing : " + this.shopInfo.name;
    return title;
  }

  save(): void {
    if (this.editForm.valid) {
      // FIX: Prepare selected departments (filter is_exist: true, remove flag)
      const selectedDepts = this.shopInfo.departments
        .filter(d => d.is_exist)
        .map(d => ({ ...d, is_exist: 1 }));

      // FIX: Prepare payroll_groups (single, from form)
      const payrollGroups = [{
        payroll_group_id: this.editForm.value.payroll_group_id ? Number(this.editForm.value.payroll_group_id) : null,
        cost_code: this.editForm.value.cost_code || null
      }];

      const formValue = { ...this.editForm.getRawValue() };
      if (formValue.start_date) {
        formValue.start_date = moment(formValue.start_date).format('YYYY-MM-DD');
      } else {
        formValue.start_date = null;
      }

      if (!this.isProductionMode) {
        formValue.is_excluded_summary = 1;
      } else {
        formValue.is_excluded_summary = (formValue.is_excluded_summary === 1 || formValue.is_excluded_summary === true || formValue.is_excluded_summary === '1') ? 1 : 0;
      }

      const payloadToSave = {
        ...this.shopInfo,
        ...formValue,
        departments: selectedDepts,
        payroll_groups: payrollGroups
      };

      this.shopService.update(payloadToSave).subscribe({
        next: (response) => {
          if (response.status == 'SUCCESS') {
            this.isDepartmentsDirty = false;
            this.editForm.markAsPristine();
            this.payrollGroupSearch.markAsPristine();
            let snckBarData: SnackBarData = {
              type: 'success',
              title: 'Saved',
              message: 'The record for ' + payloadToSave.name + " has been updated succesfully."
            };
            this.snackBarService.openSnackBar(snckBarData);
            if (this.userData?.user_type == 'HQ') {
              const isCreate = !this.shopInfo.id || this.shopInfo.id === 0;
              if (isCreate) {
                this.router.navigate(['/system/shop']);
              } else {
                this.router.navigate(['/system/shop'], {
                  queryParams: {
                    lastAction: 'UPDATE',
                    actionId: this.shopInfo.id
                  }
                });
              }
            }
            if (this.userData?.user_type == 'SHOP') {
              // this.router.navigate(['/kitchen']);
            }
          } else if (response.code === 'DATA_CHANGED_AT_SERVER') {
            let snackBarData: SnackBarData = {
              message: 'This record has been updated by another user. Please reload the data to see the latest changes.',
              title: 'Conflict Detected',
              type: 'error'
            }
            this.snackBarService.openSnackBar(snackBarData);
            // Refresh the data to show the latest version from server
            if (this.shopInfo.id) {
              this.setShopInfo(this.shopInfo.id);
            }
          } else {
            let snackBarData: SnackBarData = {
              message: response.message,
              title: 'Failed!!!',
              type: 'error'
            };
            this.snackBarService.openSnackBar(snackBarData);
          }
        },
        error: (error) => {
          let snackBarData: SnackBarData = {
            message: 'Failed to update. Connection to the server failed',
            title: 'Failed!!!',
            type: 'error'
          };
          this.snackBarService.openSnackBar(snackBarData);
        }
      });
    } else {
      this.editForm.markAllAsTouched();
      this.payrollGroupSearch.markAsTouched();
    }
  }

  onShopTypeChange() {
    let shopType = this.selected_shop_type;
    const mainShop = this.editForm.get('main_shop_id');
    const dtSushi = this.editForm.get('dt_sushi_shop_id');
    const dtBento = this.editForm.get('dt_bento_shop_id');
    // Clear all validators first
    [mainShop, dtSushi, dtBento].forEach(control => {
      control?.clearValidators();
      control?.updateValueAndValidity();
    });

    if (this.selected_shop_type === 'SUSHI') {
      this.is_display_bento_shop = false;
      this.is_display_dt_shops = false;
      this.isDisabled = true;
    } else if (this.selected_shop_type === 'OO') {
      this.is_display_bento_shop = false;
      this.is_display_dt_shops = false;
      this.isDisabled = false;
    } else if (this.selected_shop_type === 'BENTO') {
      this.is_display_bento_shop = true;
      this.is_display_dt_shops = false;
      this.isDisabled = true;
      mainShop?.setValidators([Validators.required]);
      mainShop?.updateValueAndValidity();
    } else if (this.selected_shop_type === 'DT') {
      this.is_display_bento_shop = false;
      this.is_display_dt_shops = true;
      this.isDisabled = false;
      dtSushi?.setValidators([Validators.required]);
      dtBento?.setValidators([Validators.required]);
      dtSushi?.updateValueAndValidity();
      dtBento?.updateValueAndValidity();
    }
    this.updateExcludeSummaryDisabledState();
  }

  onDepartmentChange(dept: any): void {
    this.isDepartmentsDirty = JSON.stringify(this.initialDepartments) !== JSON.stringify(this.shopInfo.departments);
  }

  filterPayrollGroups(value: string) {
    const filterValue = value ? value.toLowerCase() : '';
    this.filteredPayrollGroups = this.payrollGroups.filter(group =>
      group.group_name.toLowerCase().includes(filterValue)
    );
  }



  clearPayrollGroup() {
    this.editForm.get('payroll_group_id')?.setValue('');
    this.editForm.get('group_code')?.setValue('');
    this.payrollGroupSearch.setValue('');
    if (this.payrollGroupNameInput) {
      this.payrollGroupNameInput.nativeElement.value = '';
    }
    this.filteredPayrollGroups = this.payrollGroups.slice();
  }

  async publish(): Promise<void> {
    if (!this.shopInfo.id) return;
    const message = "Are you sure you want to publish this shop? This will create the shop database and copy the template data.";
    const dialogData = new ConfirmDialogModel("Publish Shop", message);
    const result = await this.confirmDialogService.openDialog(dialogData);
    if (result) {
      this.isPublishing = true;
      this.publishSuccess = false;
      this.publishStatusMessage = '';

      this.dialog.open(this.publishDialog, { disableClose: true, width: '400px' });

      this.shopService.publish(this.shopInfo.id).subscribe({
        next: (response) => {
          this.isPublishing = false;
          if (response.status == 'SUCCESS') {
            this.publishSuccess = true;
            this.publishStatusMessage = `${this.shopInfo.name} has been published successfully.`;
          } else {
            this.publishSuccess = false;
            this.publishStatusMessage = response.message || 'Publishing failed.';
          }
        },
        error: (error) => {
          this.isPublishing = false;
          this.publishSuccess = false;
          this.publishStatusMessage = 'Failed to publish. Connection to the server failed';
        }
      });
    }
  }

  closePublishDialog(): void {
    this.dialog.closeAll();
    if (this.publishSuccess && this.shopInfo.id) {
      this.setShopInfo(this.shopInfo.id);
    }
  }

  enableProductionMode(): void {
    if (!this.prodModeWarningDialog) return;
    this.prodModeStep = 1;
    this.isSummarizeSalesToHq = true;
    this.isSettingProdMode = false;
    this.dialog.open(this.prodModeWarningDialog, {
      width: '520px',
      panelClass: 'warning-dialog-panel',
      disableClose: true
    });
    this.cdr.detectChanges();
  }

  goToProductionModeStep2(): void {
    this.prodModeStep = 2;
    this.cdr.detectChanges();
  }

  confirmEnableProductionMode(): void {
    this.dialog.closeAll();
    if (!this.userData) {
      const userDetailsData = sessionStorage.getItem('user');
      if (userDetailsData) {
        this.userData = JSON.parse(userDetailsData);
      }
    }
    const currentUserId = this.userData?.id || 0;
    const p_is_exclude_summary = this.isSummarizeSalesToHq ? 0 : 1;

    if (this.shopInfo.id) {
      this.isSettingProdMode = true;
      this.prodModeSuccess = false;
      this.prodModeStatusMessage = '';

      this.dialog.open(this.prodModeLoaderDialog, { disableClose: true, width: '400px' });

      this.shopService.setProductionMode(this.shopInfo.id, currentUserId, p_is_exclude_summary).subscribe({
        next: (response) => {
          this.isSettingProdMode = false;
          if (response.status === 'SUCCESS') {
            this.prodModeSuccess = true;
            this.prodModeStatusMessage = 'The shop has been successfully set to Production Mode.';
          } else {
            this.prodModeSuccess = false;
            this.prodModeStatusMessage = response.message || 'Failed to switch shop to Production Mode.';
          }
        },
        error: (error) => {
          this.isSettingProdMode = false;
          this.prodModeSuccess = false;
          this.prodModeStatusMessage = 'Failed to switch to Production Mode. Connection to the server failed.';
        }
      });
    }
  }

  closeProdModeLoaderDialog(): void {
    this.dialog.closeAll();
    if (this.prodModeSuccess && this.shopInfo.id) {
      this.setShopInfo(this.shopInfo.id);
    }
  }

  cancelEnableProductionMode(): void {
    this.dialog.closeAll();
  }

}